import { Component } from '@angular/core';

@Component({
  selector: 'icon-launched-campaign',
  templateUrl: './icon-launched-campaign.component.html',
  styleUrls: ['./icon-launched-campaign.component.scss']
})
export class IconLaunchedCampaignComponent {}
